import React from 'react';

import { Checkbox as AntdCheckbox } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';

import { FilterButton } from 'components/WrappedComponents';

import { FilterDashboardMotifMef } from '../../types';

import FilterFormMotifMef from './FilterFormMotifMef';

interface FilterProps {
  setFilter: (value: Partial<FilterDashboardMotifMef>) => void;
  filter: Partial<FilterDashboardMotifMef>;
}

export default function Filter({
  filter,
  setFilter,
}: FilterProps): React.ReactElement {
  const { enabled, ...formFilter } = filter;
  function setFormFilter(value: Partial<FilterDashboardMotifMef>) {
    setFilter({
      ...filter,
      ...value,
    });
  }

  function setDisplayInvalidMotif(event: CheckboxChangeEvent) {
    setFilter({
      ...filter,
      enabled: !event.target.checked,
    });
  }

  return (
    <div className="dashboard-header-filter">
      <FilterButton
        filter={formFilter}
        setFilter={setFormFilter}
        textInactiveFilter="Filtres"
        textActiveFilter="Filtres (actifs)"
      >
        {(setData, data) => (
          <FilterFormMotifMef filter={data} setFilter={setData} />
        )}
      </FilterButton>
      <AntdCheckbox checked={!enabled} onChange={setDisplayInvalidMotif}>
        Afficher les motifs inactifs
      </AntdCheckbox>
    </div>
  );
}
